import { initResponsiveSlidesCarousel } from './responsive-slides-carousel'

export const initSpecialOfferCarousel = (): void => {
  const $offerCarousels = document.getElementById('special-offer-carousel')

  initResponsiveSlidesCarousel($offerCarousels)
}
